import script from "./ShiftForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftForm.vue?vue&type=script&setup=true&lang=js"

import "./ShiftForm.vue?vue&type=style&index=0&id=3b75547a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b75547a"]])

export default __exports__